import * as React from "react";
const SvgQonto = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 400 400",
  ...props
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 400) scale(0.1 -0.1)",
  fill: "#000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 2000 l0 -2000 2000 0 2000 0 0 2000 0 2000 -2000 0 -2000 0 0\n-2000z m980 1115 c418 -63 772 -363 903 -765 22 -66 57 -238 57 -277 0 -19\n-57 -16 -165 6 -466 99 -819 472 -890 941 -17 111 -17 110 -7 110 4 0 50 -7\n102 -15z m2150 8 c0 -37 -33 -212 -50 -268 -68 -220 -218 -431 -410 -577 -136\n-104 -376 -199 -542 -214 -79 -8 -74 -17 -53 111 74 460 436 842 880 929 126\n24 175 29 175 19z m-1194 -1245 c-25 -244 -144 -488 -330 -674 -134 -133\n-278 -223 -451 -279 -73 -24 -273 -61 -281 -52 -2 2 1 40 6 85 52 414 346 777 745\n921 73 26 225 59 279 60 l39 1 -7 -62z m321 36 c374 -87 690 -375 813 -742 28\n-83 67 -289 57 -299 -3 -2 -49 3 -103 11 -232 35 -440 137 -610 298 -197 187\n-312 420 -349 707 l-7 54 67 -7 c37 -4 96 -14 132 -22z"
})));
export default SvgQonto;
//# sourceMappingURL=Qonto.js.map